module.exports = __webpack_public_path__ + "static/assets/402c0b57b10e4f8551b261315045941a.png";